import { Spinner } from 'components/Elements';
import { Dashboard } from 'features/misc';
import { Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
// import { lazyImport } from 'utils/lazyImport';

const App = () => {
  return (
    <>
      <Suspense
        fallback={
          <div className="h-full w-full flex items-center justify-center">
            <Spinner size="xl" />
          </div>
        }
      >
        <Outlet />
      </Suspense>
    </>
  );
};

export const protectedRoutes = [
  {
    path: '/app',
    element: <App />,
    children: [
      // { path: '/app/my-projects/*', element: <MyProjectsRoutes /> },
      { path: '/app', element: <Dashboard /> },
      { path: '*', element: <Navigate to="." /> },
    ],
  },
];
